// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://easyid.uat.codezync.net:5400/',
  authUrl:"https://easykc.codezync.net:8443",
  clientId:"easyid-admins-staging-client",
  clientSecret:"0lWHQ8OksPUXv0zxPQcCW4IHlQyO4tMp",
  signalRUrl:"https://easyid.uat.codezync.net:5400/notificationHub",

  realm:"easyid-admins-staging-realm",
  appRealm: 'cards-print-members-realm'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
